module.exports = __webpack_public_path__ + "static/fonts/FontAwesome.0d2717c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/FontAwesome.otf
// module id = 692
// module chunks = 1